import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

const MoodBoardList = ({ setPage, selectMyMoodboard }) => {
	const moodboardContainerRef = useRef(null);

	const selectedMoodboard = useSelector((store) => store.trendResearchStore.selectedMoodboard);
	const moodboards = useSelector((store) => store.trendResearchStore.allMoodboards);

	const renderMoodboardImages = (imageUrlList) => {
		const defaultImage = `${process.env.PUBLIC_URL}/images/default-dress.png`;
		const maxImages = 4;

		// Ensure the array has 4 images by filling missing ones with defaultImage
		const imagesToRender = [...imageUrlList];
		while (imagesToRender.length < maxImages) {
			imagesToRender.push(defaultImage);
		}

		return imagesToRender
			.slice(0, maxImages)
			.map((imageUrl, index) => (
				<img key={index} src={imageUrl?.startsWith('https:') ? imageUrl : defaultImage} />
			));
	};

	const handleScroll = () => {
		const container = moodboardContainerRef.current;
		if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
			setPage((prev) => prev + 1); // Load more when scrolled to the bottom
		}
	};

	useEffect(() => {
		const container = moodboardContainerRef.current;
		if (container) {
			container.addEventListener('scroll', handleScroll);
		}

		return () => {
			if (container) {
				container.removeEventListener('scroll', handleScroll);
			}
		};
	}, []);

	const selectSingleMoodboard = async (moodboard) => {
		selectMyMoodboard(moodboard);
	};

	return (
		<div
			ref={moodboardContainerRef}
			className={`all-select-moodboard 
			${moodboards?.length < 2 ? 'single-moodbord-sidber' : ''} 
			scroll-y-label`}
		>
			{moodboards?.map((moodboard) => {
				return (
					<div
						key={moodboard?.id}
						className={`single-moodbord d-flex align-items-center align-self-center mb-12 cursor-pointer ${
							selectedMoodboard?.[0]?.id === moodboard?.id ? 'active' : ''
						}`}
						onClick={() => selectSingleMoodboard(moodboard)}
					>
						<div className="design-images">
							{renderMoodboardImages(moodboard.imageUrlList || [])}
						</div>
						<div className="product-content ml-12">
							<p className="regular-14 weight-500 gray_dark_01 pb-1">{moodboard?.name}</p>
							<p className="regular-14  gray_dark_02">{moodboard?.brandName || ''}</p>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default MoodBoardList;
